import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetodwarkabusonrent() {



  const cardData =
  {
    keyword: 'Pune Dwarka Bus On Rent',
    heading: 'Sanavi Travels: Pune Dwarka Bus On Rent',
    headingDescription: 'Sanavi Travels offers Pune to Dwarka Bus On Rent, providing safe, comfortable, and well-organized transportation for pilgrims, families, and group travelers visiting the holy city of Dwarka. Our fleet of well-maintained AC and Non-AC buses, mini buses, and luxury coaches ensures spacious seating, smooth long-distance travel, and ample luggage space for a hassle-free journey. With experienced drivers, flexible one-way and round-trip bus rental options, transparent pricing, and 24/7 booking support, renting a bus from Pune to Dwarka is convenient, reliable, and stress-free. Choose Sanavi Travels for trusted Pune to Dwarka bus rental services, delivering comfort, safety, and a memorable pilgrimage travel experience.',

    top: 'Top Places to Visit in Dwarka with Sanavi Travels',


"topPlaces": [
  {
    "title": "Dwarkadhish Temple",
    "description": "Dwarkadhish Temple, also known as Jagat Mandir, is one of the Char Dham pilgrimage sites and a major spiritual center in Dwarka, Gujarat. Dedicated to Lord Krishna, the temple is believed to be built over 2,500 years ago. Its towering spire, intricate carvings, and sacred inner sanctum draw thousands of devotees daily. The temple represents devotion, history, and architectural brilliance, and visiting it is considered highly auspicious for spiritual fulfillment."
  },
  {
    "title": "Bet Dwarka",
    "description": "Bet Dwarka is an island located near Dwarka, believed to be the original residence of Lord Krishna during his rule. Accessible by boat, the island has temples, ancient structures, and scenic beaches. Pilgrims and tourists alike visit Bet Dwarka to experience the historical and spiritual essence of Krishna’s life."
  },
  {
    "title": "Rukmini Devi Temple",
    "description": "The Rukmini Devi Temple, located in Dwarka, is dedicated to Goddess Rukmini, the consort of Lord Krishna. The temple is known for its beautiful architecture, peaceful ambiance, and elaborate carvings depicting mythological stories. Devotees visit to seek blessings for marital harmony, prosperity, and spiritual growth."
  },
  {
    "title": "Gomti Ghat",
    "description": "Gomti Ghat is a sacred riverfront along the Gomti River in Dwarka. Pilgrims perform holy rituals, take ceremonial dips, and offer prayers here. The ghat enhances the spiritual atmosphere of the city and is especially vibrant during festivals and special occasions."
  },
  {
    "title": "Nageshwar Jyotirlinga Temple",
    "description": "Nageshwar Temple, one of the twelve Jyotirlingas, is dedicated to Lord Shiva and located near Dwarka. Pilgrims consider it highly auspicious to visit along with Dwarkadhish Temple. The temple’s spiritual energy and architectural beauty attract devotees seeking blessings and inner peace."
  },
  {
    "title": "Gita Mandir",
    "description": "Gita Mandir, also known as the Temple of Bhagavad Gita, is dedicated to Lord Krishna and showcases artistic depictions of the Mahabharata. The temple emphasizes spiritual teachings, moral values, and devotion, making it a must-visit for pilgrims and students of Indian philosophy."
  },
  {
    "title": "Sudama Setu",
    "description": "Sudama Setu is a picturesque bridge connecting Dwarka with nearby temples and ghats. Named after Lord Krishna’s childhood friend Sudama, the bridge offers beautiful views of the Gomti River and surrounding areas. Pilgrims enjoy serene walks and reflections along this spiritual landmark."
  },
  {
    "title": "Local Markets and Culture",
    "description": "Dwarka’s local markets offer religious souvenirs, handicrafts, and traditional Gujarati snacks. Visitors can experience local culture, taste regional cuisine, and purchase items associated with Krishna devotion, enhancing the pilgrimage experience."
  },
  {
    "title": "Festivals in Dwarka",
    "description": "Dwarka comes alive during Janmashtami, Holi, Diwali, and other Krishna-related festivals. The city hosts vibrant rituals, cultural performances, processions, and devotional music, making these occasions spiritually uplifting and culturally immersive."
  },
  {
    "title": "Coastal Views and Scenic Beauty",
    "description": "Dwarka, situated along the Arabian Sea, offers stunning coastal views, especially during sunrise and sunset. Pilgrims and tourists often enjoy peaceful walks along the shore, combining spiritual reflection with natural beauty. The sea adds a serene and rejuvenating dimension to the sacred city."
  }
]
,



"services": [
{
"name": "Pune Dwarka Bus On Rent",
"description": "Pune Dwarka Bus On Rent provides reliable and comfortable bus services for travelers planning a long-distance pilgrimage or tour from Pune to Dwarka. These buses are ideal for families, groups, and individuals seeking a stress-free and organized travel experience to the holy city of Dwarka."
},
{
"name": "Dwarka Bus Hire from Pune",
"description": "Dwarka Bus Hire from Pune offers convenient and customizable bus rental options for your journey to Dwarka. Whether it’s a religious tour, family trip, or group travel, these buses ensure comfort, safety, and timely arrivals at your destination."
},
{
"name": "AC Bus Pune to Dwarka",
"description": "AC Bus Pune to Dwarka ensures a cool and comfortable journey across the long distance between Pune and Dwarka. These air-conditioned buses are equipped with modern amenities to make the travel smooth and relaxing for all passengers."
},
{
"name": "Luxury Bus Dwarka Darshan",
"description": "Luxury Bus Dwarka Darshan offers premium travel options for pilgrims and tourists seeking extra comfort and convenience. With plush seating, spacious interiors, and professional drivers, these buses make long-distance travel an enjoyable experience."
},
{
"name": "Religious Tour Bus Dwarka",
"description": "Religious Tour Bus Dwarka is designed for devotees and spiritual travelers visiting the sacred city of Dwarka. These buses provide a safe, well-organized, and comfortable travel experience for long-distance temple tours."
},
{
"name": "Family Dwarka Trip Bus",
"description": "Family Dwarka Trip Bus is perfect for family travelers looking for a comfortable, hassle-free journey from Pune to Dwarka. Spacious seating, smooth rides, and experienced chauffeurs make these trips enjoyable for all age groups."
},
{
"name": "Group Travel Dwarka Bus",
"description": "Group Travel Dwarka Bus is ideal for large groups, tour operators, or clubs planning a pilgrimage to Dwarka. High-capacity buses and organized itineraries ensure a seamless and stress-free group travel experience."
},
{
"name": "Affordable Dwarka Bus Rental",
"description": "Affordable Dwarka Bus Rental provides budget-friendly bus options without compromising on comfort or safety. Perfect for students, families, or groups seeking economical travel solutions from Pune to Dwarka."
},
{
"name": "Chauffeur Driven Bus Dwarka",
"description": "Chauffeur Driven Bus Dwarka offers skilled drivers for long-distance journeys, allowing passengers to relax and enjoy scenic routes along the way. This service ensures safe, reliable, and comfortable travel from Pune to Dwarka."
},
{
"name": "Best Dwarka Bus Service Pune",
"description": "Best Dwarka Bus Service Pune is known for its dependable buses, professional chauffeurs, and excellent customer service. Ideal for family trips, group tours, and religious pilgrimages, it guarantees a well-organized and timely journey."
},
{
"name": "Pune Dwarka Travel Bus",
"description": "Pune Dwarka Travel Bus provides fully managed travel services for pilgrims and tourists heading to Dwarka. With safe buses, comfortable seating, and experienced drivers, the journey is made enjoyable and worry-free."
},
{
"name": "Pilgrimage Bus Rental Pune",
"description": "Pilgrimage Bus Rental Pune specializes in providing buses for religious tours to Dwarka and other sacred sites. These buses focus on safety, comfort, and convenience for all devotees and pilgrimage groups."
},
{
"name": "Online Bus Booking Dwarka",
"description": "Online Bus Booking Dwarka allows travelers to book buses from Pune to Dwarka quickly and conveniently. Options include AC buses, luxury buses, and family or group travel buses, ensuring a hassle-free booking experience."
},
{
"name": "Gujarat Temple Tour Bus",
"description": "Gujarat Temple Tour Bus offers organized bus tours to Dwarka and other famous temples in Gujarat. Comfortable buses, professional chauffeurs, and planned itineraries make religious travel enjoyable and stress-free."
},
{
"name": "Char Dham Bus Tour",
"description": "Char Dham Bus Tour provides long-distance pilgrimage bus services from Pune to Dwarka as part of a spiritual journey. These buses offer comfort, safety, and convenience for devotees undertaking the sacred Char Dham circuit."
}
],
"tableData": [
["Pune Dwarka Bus On Rent", "Dwarka Bus Hire from Pune"],
["AC Bus Pune to Dwarka", "Luxury Bus Dwarka Darshan"],
["Religious Tour Bus Dwarka", "Family Dwarka Trip Bus"],
["Group Travel Dwarka Bus", "Affordable Dwarka Bus Rental"],
["Chauffeur Driven Bus Dwarka", "Best Dwarka Bus Service Pune"],
["Pune Dwarka Travel Bus", "Pilgrimage Bus Rental Pune"],
["Online Bus Booking Dwarka", "Gujarat Temple Tour Bus"],
["Char Dham Bus Tour", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Dwarka Bus On Rent with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels provides comfortable and reliable bus rental services from Pune to Dwarka, ideal for group trips, pilgrimages, and long-distance travel."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses",
    "WhyChoosedescription": "Our buses are clean, air-conditioned, and regularly serviced to ensure a smooth and enjoyable journey from Pune to Dwarka."
  },
  {
    "WhyChooseheading": "Experienced Long-Distance Drivers",
    "WhyChoosedescription": "Our professional and licensed drivers are experienced in long-distance routes, ensuring safe, timely, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers clear pricing for Pune to Dwarka bus rentals, including fuel, tolls, and driver allowances, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available around the clock to assist with bookings, itinerary planning, and travel queries during your Pune to Dwarka trip."
  },
  {
    "WhyChooseheading": "Customizable Travel Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized bus rental packages based on your group’s schedule and preferences."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Dwarka bus rentals."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services from Pune to Dwarka?',
    answer: 'Yes, Sanavi Travels offers reliable and comfortable bus rental services for long-distance travel from Pune to Dwarka.'
  },
  {
    question: 'How can I book a Pune to Dwarka bus?',
    answer: 'You can book the bus via our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for Pune to Dwarka?',
    answer: 'We offer mini buses, 20-seater, 32-seater, 45-seater, and 50-seater buses depending on your group size.'
  },
  {
    question: 'Are the drivers experienced with long-distance travel?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with long-distance routes like Pune to Dwarka.'
  },
  {
    question: 'Can I customize my travel itinerary?',
    answer: 'Absolutely, you can customize pickup points, stops, and travel schedule according to your needs.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Dwarka trip.'
  },
  {
    question: 'Are the buses sanitized before the trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized to ensure a safe and hygienic journey.'
  },
  {
    question: 'What payment methods are accepted?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for booking.'
  },
  {
    question: 'Is this bus rental suitable for group travel?',
    answer: 'Yes, Pune to Dwarka bus rentals are ideal for families, groups, and long-distance pilgrimages.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Deshmukh',
    feedback: 'Our Pune to Dwarka trip with Sanavi Travels was smooth and comfortable. Excellent service and professional drivers!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Priyanka Sharma',
    feedback: 'Sanavi Travels made our long-distance journey easy and enjoyable. Highly recommend their bus rental service.',
    rating: 5
  }
];




















































































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "BusTrip",
  "name": "Pune Dwarka Bus On Rent - Sanavi Travels",
  "description": "Sanavi Travels offers Pune to Dwarka bus rental services with AC and luxury buses. Perfect for religious trips, family visits, and group travel. Affordable, chauffeur-driven buses with online booking available.",
  "touristType": "Family Trip, Group Travel, Pilgrimage, Religious Tourism",
  "departureLocation": "Pune",
  "arrivalLocation": "Dwarka, Gujarat",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "25"
  }
};




  return (
    <div>

<Helmet>
  <title>
    Pune Dwarka Bus On Rent | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Pune to Dwarka bus rental services by Sanavi Travels. AC and luxury buses for religious trips, family visits, and group travel. Affordable, chauffeur-driven, with online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/203.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetodwarkabusonrent;